{
    "de": {
        "PROFILE": {
            "SYSTEM_PROTOCOL": {
                "LABEL": "Systemprotokoll",
                "DOWNLOAD": "Download",
                "TITLE": "Aktuelles"
            }
        }
    },
    "en": {
        "PROFILE": {
            "SYSTEM_PROTOCOL": {
                "LABEL": "System protocol",
                "DOWNLOAD": "Download",
                "TITLE": "Currently"
            }
        }
    }
}